export const countryUniversitiesMap = {
    "australia": [
        {
            "name": "The University of Melbourne",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5–7.0 (program dependent)"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February & July"
                },
                {
                    "label": "Key Strengths",
                    "value": "Australia’s leading comprehensive research university with global excellence in Medicine, Law, Business, Engineering, Computer Science, Education, and Social Sciences."
                }
            ]
        },
        {
            "name": "The University of Sydney",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5–7.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February & July"
                },
                {
                    "label": "Key Strengths",
                    "value": "One of Australia’s oldest and most prestigious universities, recognized for Medicine, Engineering, Business, Law, Architecture, and Research."
                }
            ]
        },
        {
            "name": "University of New South Wales (UNSW Sydney)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5–7.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February, June & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "World-leading university in Engineering, Computer Science, Renewable Energy, Business, Finance, and Innovation with strong industry partnerships."
                }
            ]
        },
        {
            "name": "Australian National University (ANU)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5–7.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February & July"
                },
                {
                    "label": "Key Strengths",
                    "value": "Australia’s premier research university with strengths in Public Policy, International Relations, Economics, Science, Data Science, and Research."
                }
            ]
        },
        {
            "name": "Monash University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February & July"
                },
                {
                    "label": "Key Strengths",
                    "value": "Globally recognized research university with excellence in Medicine, Pharmacy, Engineering, Business, Artificial Intelligence, Data Science, and Sustainability."
                }
            ]
        },
        {
            "name": "The University of Queensland (UQ)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February & July"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading research university known for Biotechnology, Agriculture, Environmental Science, Engineering, Medicine, Business, and Innovation."
                }
            ]
        },
        {
            "name": "The University of Western Australia (UWA)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February & July"
                },
                {
                    "label": "Key Strengths",
                    "value": "Research-intensive university with strengths in Mining Engineering, Agriculture, Marine Science, Medicine, Engineering, and Natural Sciences."
                }
            ]
        },
        {
            "name": "The University of Adelaide",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February & July"
                },
                {
                    "label": "Key Strengths",
                    "value": "Strong research university with excellence in Engineering, Computer Science, Agriculture, Health Sciences, Defence Technology, and Business."
                }
            ]
        },
        {
            "name": "University of Technology Sydney (UTS)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February, July & November (Selected Programs)"
                },
                {
                    "label": "Key Strengths",
                    "value": "Technology-focused university specializing in Computer Science, Artificial Intelligence, Data Science, Engineering, Design, and Industry-Oriented Learning."
                }
            ]
        },
        {
            "name": "RMIT University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February & July"
                },
                {
                    "label": "Key Strengths",
                    "value": "Global technology and design university known for Engineering, IT, Architecture, Business, Artificial Intelligence, and industry-focused education."
                }
            ]
        },
        {
            "name": "Macquarie University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February & July"
                },
                {
                    "label": "Key Strengths",
                    "value": "Strong in Business, Finance, Data Science, Artificial Intelligence, Medicine, Linguistics, and interdisciplinary research."
                }
            ]
        },
        {
            "name": "University of Wollongong (UOW)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February & July"
                },
                {
                    "label": "Key Strengths",
                    "value": "Research-focused university known for Engineering, Materials Science, Computer Science, Cybersecurity, Business, and Sustainability."
                }
            ]
        },
        {
            "name": "Deakin University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "March, July & November"
                },
                {
                    "label": "Key Strengths",
                    "value": "Strong in Business, Information Technology, Education, Health Sciences, Sports Science, and Industry-Based Learning."
                }
            ]
        },
        {
            "name": "Queensland University of Technology (QUT)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February & July"
                },
                {
                    "label": "Key Strengths",
                    "value": "Known as the “University for the Real World,” with strengths in Technology, Engineering, Business, Design, Entrepreneurship, and Innovation."
                }
            ]
        },
        {
            "name": "Griffith University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February, July & October"
                },
                {
                    "label": "Key Strengths",
                    "value": "Internationally recognized university with strengths in Business, Tourism, Environmental Science, Health Sciences, Law, and Sustainability."
                }
            ]
        }
    ],
    "canada": [
        {
            "name": "University of Toronto (UofT)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5–7.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September (Main Intake), January & May (Selected Programs)"
                },
                {
                    "label": "Key Strengths",
                    "value": "Canada’s highest-ranked comprehensive research university with global excellence in Medicine, Engineering, Computer Science, Artificial Intelligence, Business, Economics, and Research."
                }
            ]
        },
        {
            "name": "McGill University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & January"
                },
                {
                    "label": "Key Strengths",
                    "value": "One of Canada’s most prestigious universities with strong programs in Medicine, Law, Engineering, Science, Management, and International Research."
                }
            ]
        },
        {
            "name": "University of British Columbia (UBC)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & January"
                },
                {
                    "label": "Key Strengths",
                    "value": "World-leading public research university known for Sustainability, Engineering, Computer Science, Business, Environmental Science, and International Education."
                }
            ]
        },
        {
            "name": "University of Waterloo",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5–7.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September, January & May"
                },
                {
                    "label": "Key Strengths",
                    "value": "Canada’s leading technology and innovation university, famous for Computer Science, Artificial Intelligence, Engineering, Mathematics, Co-op Education, and Industry Partnerships."
                }
            ]
        },
        {
            "name": "McMaster University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & January"
                },
                {
                    "label": "Key Strengths",
                    "value": "Research-intensive university recognized for Medicine, Health Sciences, Engineering, Business, Science, and Innovation."
                }
            ]
        },
        {
            "name": "University of Alberta",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & January"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading research university with strengths in Engineering, Artificial Intelligence, Energy, Agriculture, Medicine, Business, and Natural Sciences."
                }
            ]
        },
        {
            "name": "Université de Montréal",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5 (French proficiency may be required for some programs)"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & January"
                },
                {
                    "label": "Key Strengths",
                    "value": "Major Canadian research university known for Artificial Intelligence, Neuroscience, Medicine, Computer Science, Law, and Social Sciences."
                }
            ]
        },
        {
            "name": "Western University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & January"
                },
                {
                    "label": "Key Strengths",
                    "value": "Prestigious research university with strengths in Business (Ivey), Management, Engineering, Health Sciences, Social Sciences, and Psychology."
                }
            ]
        },
        {
            "name": "Queen’s University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & January"
                },
                {
                    "label": "Key Strengths",
                    "value": "Historic Canadian university recognized for Business, Engineering, Medicine, Law, Economics, and strong student experience."
                }
            ]
        },
        {
            "name": "University of Calgary",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & January"
                },
                {
                    "label": "Key Strengths",
                    "value": "Research-focused university with strengths in Energy, Engineering, Business, Computer Science, Medicine, and Sustainability."
                }
            ]
        },
        {
            "name": "University of Ottawa",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & January"
                },
                {
                    "label": "Key Strengths",
                    "value": "Canada’s largest bilingual university with strong programs in Public Policy, Law, Engineering, Computer Science, Health Sciences, and International Studies."
                }
            ]
        },
        {
            "name": "Dalhousie University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & January"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading Atlantic Canadian research university known for Ocean Sciences, Medicine, Engineering, Agriculture, Law, and Sustainability."
                }
            ]
        },
        {
            "name": "Simon Fraser University (SFU)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September, January & May"
                },
                {
                    "label": "Key Strengths",
                    "value": "Innovative public research university with strengths in Computer Science, Business, Communication, Data Science, and Applied Research."
                }
            ]
        },
        {
            "name": "University of Victoria (UVic)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & January"
                },
                {
                    "label": "Key Strengths",
                    "value": "Research-intensive university recognized for Climate Science, Engineering, Computer Science, Business, Indigenous Studies, and Environmental Research."
                }
            ]
        },
        {
            "name": "York University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & January"
                },
                {
                    "label": "Key Strengths",
                    "value": "Large comprehensive university in Toronto with strengths in Business, Economics, Law, Computer Science, Social Sciences, and International Programs."
                }
            ]
        }
    ],
    "cyprus": [
        {
            "name": "University of Cyprus (UCY)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5 (alternative English qualifications or assessment accepted)"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September (Main Intake), February (Selected Programs)"
                },
                {
                    "label": "Key Strengths",
                    "value": "Cyprus’s leading public research university with strong programs in Engineering, Computer Science, Medicine, Economics, Business, Natural Sciences, and Social Sciences. It is the highest-ranked university in Cyprus with strong international research performance."
                }
            ]
        },
        {
            "name": "University of Nicosia (UNIC)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September, January & May"
                },
                {
                    "label": "Key Strengths",
                    "value": "One of the largest private universities in Cyprus; internationally recognized for Medicine, Business, Computer Science, Blockchain, Digital Innovation, and Distance Learning."
                }
            ]
        },
        {
            "name": "Cyprus University of Technology (CUT)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading public technological university specializing in Engineering, Health Sciences, Environmental Studies, Business, Communication, and Applied Research."
                }
            ]
        },
        {
            "name": "European University Cyprus (EUC)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September, January & May"
                },
                {
                    "label": "Key Strengths",
                    "value": "Strong international university with programs in Medicine, Business, Law, Psychology, Education, and Information Technology."
                }
            ]
        },
        {
            "name": "Eastern Mediterranean University (EMU)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & February"
                },
                {
                    "label": "Key Strengths",
                    "value": "Internationally oriented university with strong programs in Engineering, Architecture, Business, Tourism, Pharmacy, and Computer Science."
                }
            ]
        },
        {
            "name": "Near East University (NEU)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & February"
                },
                {
                    "label": "Key Strengths",
                    "value": "Large international university known for Medicine, Dentistry, Pharmacy, Engineering, Artificial Intelligence, and Health Sciences."
                }
            ]
        },
        {
            "name": "Frederick University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Research Programs"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & February"
                },
                {
                    "label": "Key Strengths",
                    "value": "Strong applied education provider with programs in Engineering, Maritime Studies, Business, Education, and Environmental Sciences."
                }
            ]
        },
        {
            "name": "The Cyprus Institute (CyI)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Research-focused institute specializing in Climate Science, Energy, Sustainability, Digital Heritage, Computational Science, and Advanced Research."
                }
            ]
        },
        {
            "name": "Neapolis University Pafos",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & February"
                },
                {
                    "label": "Key Strengths",
                    "value": "Strong programs in Business, Real Estate, Law, Psychology, Architecture, and Social Sciences with an international student community."
                }
            ]
        },
        {
            "name": "University of Central Lancashire Cyprus (UCLan Cyprus)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Research Programs"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1 Year"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & February"
                },
                {
                    "label": "Key Strengths",
                    "value": "UK university branch campus offering British-style education in Law, Business, Computing, Psychology, and Sports Sciences."
                }
            ]
        },
        {
            "name": "University of Limassol (UoL)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & February"
                },
                {
                    "label": "Key Strengths",
                    "value": "Focuses on Business, Economics, Technology, Finance, and Digital Transformation with strong industry connections."
                }
            ]
        },
        {
            "name": "Open University of Cyprus (OUC)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & February"
                },
                {
                    "label": "Key Strengths",
                    "value": "Cyprus’s public open university specializing in flexible learning, Business Administration, Education, Information Systems, and postgraduate studies."
                }
            ]
        },
        {
            "name": "Girne American University (GAU)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & February"
                },
                {
                    "label": "Key Strengths",
                    "value": "International university offering programs in Business, Aviation, Engineering, Tourism, Architecture, and Communication."
                }
            ]
        },
        {
            "name": "Cyprus International University (CIU)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & February"
                },
                {
                    "label": "Key Strengths",
                    "value": "International campus with strengths in Engineering, Business, Pharmacy, Health Sciences, Law, and Computer Science."
                }
            ]
        },
        {
            "name": "American University of Cyprus (AUCY)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's & Master's Programs"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & February"
                },
                {
                    "label": "Key Strengths",
                    "value": "American-style education approach with programs focused on Business, Management, International Relations, and Professional Studies."
                }
            ]
        }
    ],
    "germany": [
        {
            "name": "Technical University of Munich (TUM)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5 (program dependent)"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October & April (Selected Programs)"
                },
                {
                    "label": "Key Strengths",
                    "value": "Germany’s leading technical university with global excellence in Engineering, Computer Science, Artificial Intelligence, Robotics, Natural Sciences, Entrepreneurship, and Innovation."
                }
            ]
        },
        {
            "name": "Ludwig Maximilian University of Munich (LMU Munich)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October & April"
                },
                {
                    "label": "Key Strengths",
                    "value": "One of Europe’s leading comprehensive research universities with strengths in Medicine, Life Sciences, Physics, Economics, Law, Humanities, and Social Sciences."
                }
            ]
        },
        {
            "name": "Heidelberg University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October & April"
                },
                {
                    "label": "Key Strengths",
                    "value": "Germany’s oldest university and a world-renowned research institution with excellence in Medicine, Biotechnology, Natural Sciences, Data Science, and Humanities."
                }
            ]
        },
        {
            "name": "RWTH Aachen University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October & April"
                },
                {
                    "label": "Key Strengths",
                    "value": "Germany’s top engineering-focused university with outstanding programs in Mechanical Engineering, Automotive Engineering, Computer Science, Robotics, Energy, and Industrial Technology."
                }
            ]
        },
        {
            "name": "Humboldt University of Berlin",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October & April"
                },
                {
                    "label": "Key Strengths",
                    "value": "Prestigious research university known for Economics, Social Sciences, Humanities, Natural Sciences, Medicine, and interdisciplinary research."
                }
            ]
        },
        {
            "name": "Free University of Berlin (FU Berlin)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October & April"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading research university specializing in International Relations, Political Science, Humanities, Social Sciences, Biology, and Earth Sciences."
                }
            ]
        },
        {
            "name": "Karlsruhe Institute of Technology (KIT)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October & April"
                },
                {
                    "label": "Key Strengths",
                    "value": "Germany’s leading institution for Engineering, Computer Science, Energy Research, Artificial Intelligence, Physics, and Technology Innovation."
                }
            ]
        },
        {
            "name": "University of Bonn",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October & April"
                },
                {
                    "label": "Key Strengths",
                    "value": "Research-intensive university known for Mathematics, Economics, Agriculture, Natural Sciences, Computer Science, and International Research."
                }
            ]
        },
        {
            "name": "University of Tübingen",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October & April"
                },
                {
                    "label": "Key Strengths",
                    "value": "Strong research university with excellence in Artificial Intelligence, Neuroscience, Medicine, Cognitive Science, Philosophy, and Life Sciences."
                }
            ]
        },
        {
            "name": "University of Freiburg",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October & April"
                },
                {
                    "label": "Key Strengths",
                    "value": "Internationally recognized university with strengths in Environmental Science, Engineering, Medicine, Computer Science, Sustainability, and Research."
                }
            ]
        },
        {
            "name": "Technische Universität Berlin (TU Berlin)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October & April"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading technology university with strong programs in Engineering, Computer Science, Artificial Intelligence, Architecture, Data Science, and Innovation."
                }
            ]
        },
        {
            "name": "University of Hamburg",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October & April"
                },
                {
                    "label": "Key Strengths",
                    "value": "Comprehensive research university with strengths in Climate Science, Physics, Business, Law, Economics, Computer Science, and Marine Research."
                }
            ]
        },
        {
            "name": "University of Cologne",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October & April"
                },
                {
                    "label": "Key Strengths",
                    "value": "One of Germany’s largest universities with excellence in Business, Economics, Medicine, Law, Social Sciences, and Research."
                }
            ]
        },
        {
            "name": "Technical University of Dresden (TU Dresden)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October & April"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading technical university with strengths in Engineering, Microelectronics, Artificial Intelligence, Materials Science, Transportation, and Renewable Energy."
                }
            ]
        },
        {
            "name": "Friedrich-Alexander University Erlangen-Nürnberg (FAU)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October & April"
                },
                {
                    "label": "Key Strengths",
                    "value": "Strong research university known for Engineering, Computer Science, Medicine, Natural Sciences, Artificial Intelligence, and Industry Collaboration."
                }
            ]
        }
    ],
    "greece": [
        {
            "name": "National and Kapodistrian University of Athens (NKUA)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5 (alternative English qualifications accepted depending on program)"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September/October (Main Intake), February (Selected Programs)"
                },
                {
                    "label": "Key Strengths",
                    "value": "Greece’s oldest and one of the most prestigious universities; strong in Medicine, Law, Humanities, Science, Economics, and Research. It is among Greece’s leading universities in global rankings."
                }
            ]
        },
        {
            "name": "Aristotle University of Thessaloniki (AUTH)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September/October"
                },
                {
                    "label": "Key Strengths",
                    "value": "The largest university in Greece with strong programs in Engineering, Computer Science, Medicine, Business, Humanities, and Social Sciences."
                }
            ]
        },
        {
            "name": "National Technical University of Athens (NTUA)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 5 Years (Integrated Engineering Degree), Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Greece’s leading engineering university; internationally recognized for Civil Engineering, Architecture, Electrical Engineering, Computer Engineering, and Technology."
                }
            ]
        },
        {
            "name": "University of Crete",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Research-intensive university known for Science, Medicine, Biology, Computer Science, Physics, and Innovation."
                }
            ]
        },
        {
            "name": "University of Patras",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Strong research university with excellence in Engineering, Computer Science, Medicine, Natural Sciences, and Technology."
                }
            ]
        },
        {
            "name": "Athens University of Economics and Business (AUEB)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Greece’s leading business university; highly regarded for Economics, Finance, Accounting, Management, Data Analytics, and Entrepreneurship."
                }
            ]
        },
        {
            "name": "University of Ioannina",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Strong research-focused university with programs in Science, Medicine, Engineering, Education, and Computer Science."
                }
            ]
        },
        {
            "name": "University of Thessaly",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Growing research university with strengths in Engineering, Agriculture, Business, Health Sciences, and Environmental Studies."
                }
            ]
        },
        {
            "name": "University of the Aegean",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Known for Marine Studies, Environmental Science, Business, Tourism, Digital Innovation, and interdisciplinary research."
                }
            ]
        },
        {
            "name": "International Hellenic University (IHU)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Research Programs"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Internationally oriented university offering English-taught programs in Business, Economics, Law, Science, Technology, and International Studies."
                }
            ]
        },
        {
            "name": "Democritus University of Thrace (DUTH)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Strong programs in Medicine, Law, Engineering, Education, and Social Sciences with growing research activities."
                }
            ]
        },
        {
            "name": "Technical University of Crete (TUC)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 5 Years (Engineering), Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Specialized engineering university known for Environmental Engineering, Electrical Engineering, Architecture, Computer Science, and Technology."
                }
            ]
        },
        {
            "name": "University of Macedonia",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Strong in Economics, Business Administration, International Relations, Balkan Studies, and Applied Social Sciences."
                }
            ]
        },
        {
            "name": "University of Piraeus",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Excellent for Shipping, Maritime Studies, Business, Finance, Economics, Information Systems, and Digital Technologies."
                }
            ]
        },
        {
            "name": "Agricultural University of Athens (AUA)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Greece’s leading institution for Agriculture, Food Science, Biotechnology, Environmental Studies, and Sustainable Development."
                }
            ]
        }
    ],
    "india": [
        {
            "name": "Indian Institute of Technology Delhi (IIT Delhi)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5 (program dependent; alternative English qualifications accepted)"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "July/August & January (Selected Programs)"
                },
                {
                    "label": "Key Strengths",
                    "value": "One of India’s top-ranked institutions with global excellence in Engineering, Computer Science, Artificial Intelligence, Data Science, Renewable Energy, Innovation, and Entrepreneurship."
                }
            ]
        },
        {
            "name": "Indian Institute of Technology Bombay (IIT Bombay)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "July/August & January"
                },
                {
                    "label": "Key Strengths",
                    "value": "Premier engineering and research institution known for Technology, Computer Science, Artificial Intelligence, Engineering, Management, Innovation, and strong industry connections."
                }
            ]
        },
        {
            "name": "Indian Institute of Technology Madras (IIT Madras)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "July/August & January"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading technology institute with strengths in Artificial Intelligence, Computer Science, Engineering, Robotics, Ocean Engineering, Data Science, and Research."
                }
            ]
        },
        {
            "name": "Indian Institute of Science (IISc Bangalore)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5+"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "August & January"
                },
                {
                    "label": "Key Strengths",
                    "value": "India’s premier research university specializing in Science, Engineering, Artificial Intelligence, Biotechnology, Physics, Mathematics, and advanced research."
                }
            ]
        },
        {
            "name": "Indian Institute of Technology Kharagpur (IIT Kharagpur)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4–5 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "July/August & January"
                },
                {
                    "label": "Key Strengths",
                    "value": "One of India’s oldest IITs with excellence in Engineering, Architecture, Law, Management, Computer Science, and interdisciplinary research."
                }
            ]
        },
        {
            "name": "Indian Institute of Technology Kanpur (IIT Kanpur)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "July/August & January"
                },
                {
                    "label": "Key Strengths",
                    "value": "Globally recognized for Computer Science, Aerospace Engineering, Mathematics, Physics, Artificial Intelligence, and scientific research."
                }
            ]
        },
        {
            "name": "University of Delhi (DU)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "July/August"
                },
                {
                    "label": "Key Strengths",
                    "value": "One of India’s largest and most prestigious universities with strong programs in Economics, Business, Humanities, Sciences, Law, and Social Sciences."
                }
            ]
        },
        {
            "name": "Indian Institute of Technology Guwahati (IIT Guwahati)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "July/August & January"
                },
                {
                    "label": "Key Strengths",
                    "value": "Strong in Engineering, Computer Science, Biotechnology, Environmental Science, Artificial Intelligence, and interdisciplinary research."
                }
            ]
        },
        {
            "name": "Indian Institute of Technology Roorkee (IIT Roorkee)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4–5 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "July/August & January"
                },
                {
                    "label": "Key Strengths",
                    "value": "Historic engineering institution known for Civil Engineering, Hydrology, Architecture, Earth Sciences, Technology, and Research."
                }
            ]
        },
        {
            "name": "Jawaharlal Nehru University (JNU)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "July/August"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading research university known for International Relations, Economics, Social Sciences, Languages, Public Policy, and Humanities."
                }
            ]
        },
        {
            "name": "Indian Institute of Technology Hyderabad (IIT Hyderabad)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "July/August & January"
                },
                {
                    "label": "Key Strengths",
                    "value": "Emerging technology-focused institute specializing in Artificial Intelligence, Computer Science, Biomedical Engineering, Robotics, and Innovation."
                }
            ]
        },
        {
            "name": "Birla Institute of Technology and Science, Pilani (BITS Pilani)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "August & January"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading private research university known for Engineering, Computer Science, Biotechnology, Business, Entrepreneurship, and industry collaboration."
                }
            ]
        },
        {
            "name": "Anna University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "August & January"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading public technical university specializing in Engineering, Technology, Computer Science, Architecture, and Applied Research."
                }
            ]
        },
        {
            "name": "University of Hyderabad (UoH)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "July/August"
                },
                {
                    "label": "Key Strengths",
                    "value": "Research-intensive university with strong programs in Science, Biotechnology, Computer Science, Economics, Social Sciences, and Humanities."
                }
            ]
        },
        {
            "name": "Savitribai Phule Pune University (SPPU)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "July/August"
                },
                {
                    "label": "Key Strengths",
                    "value": "Major public research university with strengths in Science, Technology, Management, Economics, Languages, and Social Sciences."
                }
            ]
        }
    ],
    "japan": [
        {
            "name": "The University of Tokyo (UTokyo)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5 (program dependent)"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "April & October"
                },
                {
                    "label": "Key Strengths",
                    "value": "Japan’s highest-ranked university and leading research institution with excellence in Engineering, Computer Science, Artificial Intelligence, Economics, Medicine, Law, Natural Sciences, and Global Research."
                }
            ]
        },
        {
            "name": "Kyoto University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "April & October"
                },
                {
                    "label": "Key Strengths",
                    "value": "One of Japan’s most prestigious research universities with strengths in Science, Medicine, Engineering, Chemistry, Biotechnology, Environmental Studies, and Fundamental Research."
                }
            ]
        },
        {
            "name": "Tohoku University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "April & October"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading national research university known for Materials Science, Engineering, Robotics, Computer Science, Disaster Science, and Advanced Technology Research."
                }
            ]
        },
        {
            "name": "The University of Osaka (Osaka University)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "April & October"
                },
                {
                    "label": "Key Strengths",
                    "value": "Major comprehensive research university with excellence in Engineering, Medicine, Immunology, Biotechnology, Artificial Intelligence, and Natural Sciences."
                }
            ]
        },
        {
            "name": "Institute of Science Tokyo (Science Tokyo)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "April & October"
                },
                {
                    "label": "Key Strengths",
                    "value": "Japan’s premier science and technology institution specializing in Engineering, Computer Science, Artificial Intelligence, Robotics, Materials Science, and Innovation."
                }
            ]
        },
        {
            "name": "Nagoya University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "April & October"
                },
                {
                    "label": "Key Strengths",
                    "value": "Research-intensive university known for Automotive Engineering, Physics, Chemistry, Engineering, Materials Science, and Nobel Prize-level research achievements."
                }
            ]
        },
        {
            "name": "Kyushu University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "April & October"
                },
                {
                    "label": "Key Strengths",
                    "value": "Comprehensive research university with strengths in Engineering, Energy, Environmental Science, Medicine, Agriculture, and International Research."
                }
            ]
        },
        {
            "name": "Hokkaido University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "April & October"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading national university known for Agriculture, Environmental Science, Veterinary Medicine, Engineering, Biotechnology, and Sustainability Research."
                }
            ]
        },
        {
            "name": "Keio University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "April & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Japan’s leading private university with strong programs in Business, Economics, Law, Computer Science, Media, and International Studies."
                }
            ]
        },
        {
            "name": "Waseda University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "April & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Globally recognized private university known for Business, Political Science, International Relations, Engineering, Computer Science, and Global Education."
                }
            ]
        },
        {
            "name": "University of Tsukuba",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "April & October"
                },
                {
                    "label": "Key Strengths",
                    "value": "Research-focused university specializing in Computer Science, Artificial Intelligence, Life Sciences, Sports Science, Education, and Interdisciplinary Research."
                }
            ]
        },
        {
            "name": "Kobe University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "April & October"
                },
                {
                    "label": "Key Strengths",
                    "value": "Strong comprehensive university known for Business Administration, Economics, Engineering, Medicine, Maritime Sciences, and International Studies."
                }
            ]
        },
        {
            "name": "Hiroshima University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "April & October"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading national university with strengths in Education, Engineering, Natural Sciences, Peace Studies, Medicine, and Sustainability Research."
                }
            ]
        },
        {
            "name": "Ritsumeikan University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "April & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Internationally oriented private university offering strong programs in Business, International Relations, Information Science, Engineering, and Global Studies."
                }
            ]
        },
        {
            "name": "Osaka Metropolitan University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "April & October"
                },
                {
                    "label": "Key Strengths",
                    "value": "Public research university with strengths in Engineering, Medicine, Science, Economics, Agriculture, and Urban Innovation."
                }
            ]
        }
    ],
    "malaysia": [
        {
            "name": "Universiti Malaya (UM)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5 (depending on program); alternative English qualifications accepted"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Malaysia’s highest-ranked university; excellent in Medicine, Engineering, Business, Computer Science, Law, and Social Sciences; strongest research reputation in Southeast Asia."
                }
            ]
        },
        {
            "name": "Universiti Sains Malaysia (USM)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "5.5–6.5 (program dependent)"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & February"
                },
                {
                    "label": "Key Strengths",
                    "value": "APEX research university; internationally recognized for Science, Engineering, Healthcare, Pharmacy, and Sustainability research."
                }
            ]
        },
        {
            "name": "Universiti Kebangsaan Malaysia (UKM)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "National research university with strong programs in Medicine, Law, Business, Social Sciences, Engineering, and Public Policy."
                }
            ]
        },
        {
            "name": "Universiti Putra Malaysia (UPM)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading research university in Agriculture, Biotechnology, Environmental Science, Engineering, Economics, and Life Sciences."
                }
            ]
        },
        {
            "name": "Universiti Teknologi Malaysia (UTM)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Malaysia’s leading technology university; excellent in Engineering, Artificial Intelligence, Computer Science, Robotics, and Architecture."
                }
            ]
        },
        {
            "name": "Universiti Teknologi PETRONAS (UTP)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "5.0–6.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "January & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Industry-focused university backed by PETRONAS; strong in Petroleum Engineering, Energy, Chemical Engineering, AI, and Technology."
                }
            ]
        },
        {
            "name": "Taylor's University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Professional Programs"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "5.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "January, April & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "One of Malaysia’s leading private universities; strong in Hospitality, Business, Communication, Design, Computing, and Tourism."
                }
            ]
        },
        {
            "name": "UCSI University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "January, May & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Strong international student community; recognized for Medicine, Engineering, Business, Music, and Hospitality."
                }
            ]
        },
        {
            "name": "Sunway University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Research Programs"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "January, April & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Internationally connected university; strong in Business, Computing, Psychology, Hospitality, and Data Science."
                }
            ]
        },
        {
            "name": "Monash University Malaysia",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Research Degrees"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February & July"
                },
                {
                    "label": "Key Strengths",
                    "value": "Australian Group of Eight university campus; globally recognized degrees in Medicine, Engineering, Business, IT, and Science."
                }
            ]
        },
        {
            "name": "University of Nottingham Malaysia",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & PhD"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1 Year, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "UK Russell Group university campus; strong in Engineering, Business, Economics, Education, and Science."
                }
            ]
        },
        {
            "name": "Heriot-Watt University Malaysia",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Research Programs"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1 Year"
                },
                {
                    "label": "Intake Timeline",
                    "value": "January, May & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "UK university branch campus; strong in Engineering, Business, Data Science, and Finance."
                }
            ]
        },
        {
            "name": "Multimedia University (MMU)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Research Programs"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "5.5–6.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February, June & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Malaysia’s leading digital technology university; strong in Computer Science, Software Engineering, AI, Multimedia, and Telecommunications."
                }
            ]
        },
        {
            "name": "Universiti Utara Malaysia (UUM)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Malaysia’s top management-focused university; excellent in Business, Economics, Accounting, Finance, and Management Studies."
                }
            ]
        },
        {
            "name": "Asia Pacific University of Technology & Innovation (APU)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Professional Programs"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "5.0–6.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "January, May & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Technology-focused private university; strong in Artificial Intelligence, Cybersecurity, Software Engineering, Data Analytics, and Business Technology."
                }
            ]
        }
    ],
    "malta": [
        {
            "name": "University of Malta (UM)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5 (alternative English qualifications or internal assessment may be accepted)"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October (Main Intake), February (Limited Programs)"
                },
                {
                    "label": "Key Strengths",
                    "value": "Malta’s leading public research university with strong programs in Medicine, Engineering, Artificial Intelligence, ICT, Business, Law, Science, and Sustainability. It is the highest-ranked university in Malta."
                }
            ]
        },
        {
            "name": "Malta College of Arts, Science and Technology (MCAST)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Professional & Technical Programs"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.0 (alternative English assessment available)"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October & February"
                },
                {
                    "label": "Key Strengths",
                    "value": "Malta’s leading vocational and applied sciences institution with strong links to industry; excellent in Engineering, ICT, Business, Creative Arts, Health Sciences, and Applied Technology."
                }
            ]
        },
        {
            "name": "American University of Malta (AUM)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0 (alternative English proof accepted)"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "January & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "American-style education model with programs in Business, Engineering, Finance, and Management; international learning environment."
                }
            ]
        },
        {
            "name": "Global College Malta (GCM)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Professional Programs"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1 Year"
                },
                {
                    "label": "Intake Timeline",
                    "value": "January, May & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Focuses on Business, Management, Finance, and International Relations with flexible study options for international students."
                }
            ]
        },
        {
            "name": "Malta International Business School (MIBS)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Professional Programs"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Specialized institution focusing on Business Administration, Management, Finance, Entrepreneurship, and International Business."
                }
            ]
        },
        {
            "name": "Queen Mary University of London Malta Campus",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Professional Programs"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1 Year"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "UK university presence in Malta; internationally recognized British education with focus on medicine and healthcare-related studies."
                }
            ]
        },
        {
            "name": "American University of Malta – School of Business",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's & Master's"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "6.0 or equivalent"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "January & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Strong focus on Business Administration, Entrepreneurship, Finance, and International Management."
                }
            ]
        },
        {
            "name": "STC Training Malta (STC Higher Education)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Professional & Higher Education Programs"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Professional Programs: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February, June & October"
                },
                {
                    "label": "Key Strengths",
                    "value": "Career-oriented education with strong focus on Business, IT, Digital Skills, and professional development."
                }
            ]
        },
        {
            "name": "Institute of Tourism Studies (ITS Malta)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Professional Programs"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October"
                },
                {
                    "label": "Key Strengths",
                    "value": "Malta’s specialist institution for Tourism, Hospitality, Events Management, Culinary Arts, and Travel Industries."
                }
            ]
        },
        {
            "name": "Global School of Aviation (GSA Malta)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Professional Aviation Programs, Undergraduate Pathways"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.0"
                },
                {
                    "label": "Duration",
                    "value": "1–4 Years depending on program"
                },
                {
                    "label": "Intake Timeline",
                    "value": "Multiple Intakes"
                },
                {
                    "label": "Key Strengths",
                    "value": "Aviation-focused education including aviation management, pilot training pathways, and industry-specific skills."
                }
            ]
        },
        {
            "name": "London School of Commerce Malta (LSC Malta)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Business Programs"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1 Year"
                },
                {
                    "label": "Intake Timeline",
                    "value": "January, May & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "International business education provider offering affordable programs in Business, Management, and Finance."
                }
            ]
        },
        {
            "name": "European Graduate School Malta",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Master's, Research & Doctoral Programs"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0+"
                },
                {
                    "label": "Duration",
                    "value": "Master's: 1–2 Years, Doctorate: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Specialized postgraduate institution focusing on philosophy, arts, humanities, and interdisciplinary research."
                }
            ]
        },
        {
            "name": "Institute of Digital Education Malta",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Professional Programs"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "January & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Focuses on digital education, technology skills, online learning, and professional development."
                }
            ]
        },
        {
            "name": "European Business School Malta",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Executive Programs"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1 Year"
                },
                {
                    "label": "Intake Timeline",
                    "value": "February & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Business-focused institution offering programs in Management, Entrepreneurship, Marketing, and Finance."
                }
            ]
        },
        {
            "name": "Malta Business School",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Professional Programs"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "January & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Specialized business education provider focusing on Management, Leadership, Entrepreneurship, and Corporate Skills."
                }
            ]
        }
    ],
    "southkorea": [
        {
            "name": "Seoul National University (SNU)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5 (program dependent)"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "March & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "South Korea’s top comprehensive research university with excellence in Engineering, Computer Science, AI, Business, Medicine, Economics, Law, and Social Sciences."
                }
            ]
        },
        {
            "name": "Korea Advanced Institute of Science and Technology (KAIST)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "March & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Korea’s leading science and technology university specializing in Artificial Intelligence, Robotics, Engineering, Computer Science, Biotechnology, Semiconductors, and Innovation."
                }
            ]
        },
        {
            "name": "Yonsei University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "March & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "One of Korea’s most prestigious private universities with strong programs in Business, Medicine, Engineering, International Studies, Economics, and Global Education."
                }
            ]
        },
        {
            "name": "Sungkyunkwan University (SKKU)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "March & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Research-focused university with strong industry collaboration, especially in Engineering, Artificial Intelligence, Semiconductor Technology, Business, Medicine, and Data Science."
                }
            ]
        },
        {
            "name": "Pohang University of Science and Technology (POSTECH)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "March & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Elite science and engineering research university known for Materials Science, Engineering, Physics, Chemistry, AI, and advanced technology research."
                }
            ]
        },
        {
            "name": "Korea University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "March & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading private university recognized for Business, Economics, Law, International Studies, Engineering, Computer Science, and Research."
                }
            ]
        },
        {
            "name": "Hanyang University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "March & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Technology-oriented university with strong programs in Engineering, Architecture, Computer Science, Robotics, Business, and Entrepreneurship."
                }
            ]
        },
        {
            "name": "Ulsan National Institute of Science and Technology (UNIST)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "March & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Research-focused science and technology university specializing in AI, Energy Engineering, Nanotechnology, Materials Science, and Future Technologies."
                }
            ]
        },
        {
            "name": "Gwangju Institute of Science and Technology (GIST)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "March & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading research institute specializing in Science, Engineering, AI, Renewable Energy, Nanotechnology, and Advanced Research."
                }
            ]
        },
        {
            "name": "Kyung Hee University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "March & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Comprehensive university known for International Studies, Business, Hospitality, Medicine, Humanities, and Global Education."
                }
            ]
        },
        {
            "name": "Ewha Womans University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "March & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Korea’s leading comprehensive university with strengths in Business, International Studies, Science, Engineering, Education, and Research."
                }
            ]
        },
        {
            "name": "Pusan National University (PNU)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "March & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Major national research university with strengths in Engineering, Natural Sciences, Marine Science, Business, Medicine, and Regional Development."
                }
            ]
        },
        {
            "name": "Chung-Ang University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "March & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Well-known private university with strong programs in Business, Media, Arts, Pharmacy, Engineering, and International Studies."
                }
            ]
        },
        {
            "name": "Kyungpook National University (KNU)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "March & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading national university with excellence in Engineering, IT, Biotechnology, Agriculture, Medicine, and Scientific Research."
                }
            ]
        },
        {
            "name": "Sejong University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "March & September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Growing international university recognized for Hospitality & Tourism, Business, Artificial Intelligence, Engineering, and Creative Industries."
                }
            ]
        }
    ],
    "uk": [
        {
            "name": "University of Oxford",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 7.0–7.5 (program dependent)"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1 Year, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October (Main Intake)"
                },
                {
                    "label": "Key Strengths",
                    "value": "One of the world’s oldest and most prestigious universities with outstanding strengths in Medicine, Law, Economics, Computer Science, Public Policy, Humanities, and Research."
                }
            ]
        },
        {
            "name": "University of Cambridge",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 7.0–7.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1 Year, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October"
                },
                {
                    "label": "Key Strengths",
                    "value": "Globally renowned research university with excellence in Engineering, Mathematics, Computer Science, Natural Sciences, Economics, Medicine, and Technology Innovation."
                }
            ]
        },
        {
            "name": "Imperial College London",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5–7.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1 Year, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October"
                },
                {
                    "label": "Key Strengths",
                    "value": "World-leading STEM university specializing in Engineering, Artificial Intelligence, Medicine, Data Science, Business, Climate Technology, and Innovation."
                }
            ]
        },
        {
            "name": "University College London (UCL)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5–7.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1 Year, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September/October"
                },
                {
                    "label": "Key Strengths",
                    "value": "One of the UK’s largest research universities with strengths in Architecture, Computer Science, Engineering, Education, Medicine, Psychology, and Social Sciences."
                }
            ]
        },
        {
            "name": "University of Edinburgh",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5–7.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1 Year, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading Scottish research university known for Artificial Intelligence, Informatics, Medicine, Business, Engineering, and Humanities."
                }
            ]
        },
        {
            "name": "King’s College London (KCL)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5–7.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1 Year, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Prestigious London university with excellence in Medicine, Law, International Relations, Psychology, Business, Digital Technology, and Health Sciences."
                }
            ]
        },
        {
            "name": "London School of Economics and Political Science (LSE)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 7.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1 Year, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "World-leading institution for Economics, Finance, Business, Social Sciences, International Relations, Public Policy, and Political Science."
                }
            ]
        },
        {
            "name": "University of Manchester",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5–7.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1 Year, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Major research university with strengths in Engineering, Computer Science, Business, Medicine, Materials Science, and Innovation."
                }
            ]
        },
        {
            "name": "University of Bristol",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5–7.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1 Year, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Russell Group research university recognized for Engineering, Aerospace, Computer Science, Medicine, Economics, and Environmental Research."
                }
            ]
        },
        {
            "name": "University of Warwick",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5–7.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1 Year, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Highly regarded university with excellence in Business, Economics, Mathematics, Computer Science, Engineering, and Management Studies."
                }
            ]
        },
        {
            "name": "University of Glasgow",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5–7.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1 Year, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Historic Scottish university with strengths in Medicine, Engineering, Computing, Business, Life Sciences, and Research."
                }
            ]
        },
        {
            "name": "University of Birmingham",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1 Year, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading research university with strong programs in Engineering, Business, Medicine, Computer Science, Law, and Social Sciences."
                }
            ]
        },
        {
            "name": "University of Southampton",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1 Year, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Globally recognized for Engineering, Electronics, Computer Science, Artificial Intelligence, Oceanography, and Research Innovation."
                }
            ]
        },
        {
            "name": "University of Leeds",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1 Year, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Russell Group university with strengths in Engineering, Business, Environmental Science, Medicine, Transport Studies, and Data Science."
                }
            ]
        },
        {
            "name": "University of Nottingham",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1 Year, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Internationally recognized university with strengths in Engineering, Business, Computer Science, Medicine, Pharmacy, and Global Education."
                }
            ]
        }
    ],
    "usa": [
        {
            "name": "Massachusetts Institute of Technology (MIT)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 7.0+ (alternative English tests accepted depending on program)"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September (Main Intake), January (Selected Programs)"
                },
                {
                    "label": "Key Strengths",
                    "value": "World-leading university in Engineering, Computer Science, Artificial Intelligence, Robotics, Data Science, Physics, Entrepreneurship, and technological innovation."
                }
            ]
        },
        {
            "name": "Stanford University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 7.0+"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Globally recognized for Computer Science, AI, Business, Engineering, Entrepreneurship, Medicine, and its strong connection with Silicon Valley."
                }
            ]
        },
        {
            "name": "Harvard University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 7.0+"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "One of the world's most prestigious universities with outstanding programs in Business, Law, Medicine, Public Policy, Economics, Social Sciences, and Research."
                }
            ]
        },
        {
            "name": "California Institute of Technology (Caltech)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 7.0+"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Elite science and engineering university known for Physics, Space Science, Artificial Intelligence, Engineering, Mathematics, and research innovation."
                }
            ]
        },
        {
            "name": "Princeton University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 7.0+"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Highly research-focused institution with strengths in Mathematics, Physics, Economics, Public Policy, Engineering, and Humanities."
                }
            ]
        },
        {
            "name": "University of California, Berkeley (UC Berkeley)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5–7.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "August/September, January (Limited Programs)"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading public research university with excellence in Computer Science, AI, Engineering, Environmental Science, Business, and Social Sciences."
                }
            ]
        },
        {
            "name": "Yale University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 7.0+"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Globally respected institution known for Law, Humanities, Political Science, Economics, Medicine, Arts, and interdisciplinary research."
                }
            ]
        },
        {
            "name": "Columbia University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 7.0+"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & January (Selected Programs)"
                },
                {
                    "label": "Key Strengths",
                    "value": "Ivy League university located in New York City with strong programs in Business, Engineering, Journalism, International Affairs, Data Science, and Research."
                }
            ]
        },
        {
            "name": "University of Chicago",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 7.0+"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading research university recognized for Economics, Business, Social Sciences, Public Policy, Mathematics, and Analytical research."
                }
            ]
        },
        {
            "name": "Cornell University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 7.0+"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Ivy League institution with strengths in Engineering, Computer Science, Agriculture, Business, Architecture, and Life Sciences."
                }
            ]
        },
        {
            "name": "University of Pennsylvania (UPenn)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 7.0+"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Ivy League university known for Business (Wharton), Finance, Economics, Healthcare, Engineering, and interdisciplinary programs."
                }
            ]
        },
        {
            "name": "Johns Hopkins University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 7.0+"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & January (Selected Programs)"
                },
                {
                    "label": "Key Strengths",
                    "value": "World-renowned for Medicine, Public Health, Biomedical Sciences, Biotechnology, International Relations, and Research."
                }
            ]
        },
        {
            "name": "University of Michigan–Ann Arbor",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5–7.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & January"
                },
                {
                    "label": "Key Strengths",
                    "value": "Top public research university with strengths in Engineering, Computer Science, Business, Medicine, Data Science, and Social Sciences."
                }
            ]
        },
        {
            "name": "Carnegie Mellon University (CMU)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 7.0+"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & January (Selected Programs)"
                },
                {
                    "label": "Key Strengths",
                    "value": "World leader in Computer Science, Artificial Intelligence, Robotics, Cybersecurity, Software Engineering, and Technology Innovation."
                }
            ]
        },
        {
            "name": "University of Washington (UW Seattle)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5–7.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 4–6 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & January"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading public research university with strong programs in Computer Science, AI, Engineering, Medicine, Environmental Science, and Biotechnology."
                }
            ]
        }
    ],
    "vietnam": [
        {
            "name": "Vietnam National University, Hanoi (VNU Hanoi)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5 (program dependent; alternative English qualifications accepted)"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September (Main Intake), February (Selected Programs)"
                },
                {
                    "label": "Key Strengths",
                    "value": "Vietnam’s leading comprehensive public research university with strong programs in Computer Science, Engineering, Natural Sciences, Economics, Business, Education, and Social Sciences. It is one of the highest-ranked Vietnamese universities internationally."
                }
            ]
        },
        {
            "name": "Vietnam National University Ho Chi Minh City (VNU-HCM)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & February"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading public research university in southern Vietnam with excellence in Engineering, Information Technology, Science, Economics, Biotechnology, and Innovation."
                }
            ]
        },
        {
            "name": "Duy Tan University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & February"
                },
                {
                    "label": "Key Strengths",
                    "value": "One of Vietnam’s highest-ranked private universities with strong international partnerships and programs in Computer Science, Engineering, Business, Artificial Intelligence, and Healthcare."
                }
            ]
        },
        {
            "name": "Ton Duc Thang University (TDTU)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & February"
                },
                {
                    "label": "Key Strengths",
                    "value": "Research-oriented university known for Engineering, Information Technology, Business, Architecture, Sports Science, and international collaboration."
                }
            ]
        },
        {
            "name": "Hanoi University of Science and Technology (HUST)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4–5 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Vietnam’s premier technology university specializing in Engineering, Artificial Intelligence, Computer Science, Electronics, Automation, Robotics, and Applied Sciences."
                }
            ]
        },
        {
            "name": "University of Danang (UD)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & February"
                },
                {
                    "label": "Key Strengths",
                    "value": "Major regional university with strong programs in Engineering, Technology, Economics, Foreign Languages, Education, and Research."
                }
            ]
        },
        {
            "name": "Ho Chi Minh City University of Technology (HCMUT)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading engineering institution with strengths in Civil Engineering, Mechanical Engineering, Computer Engineering, Electrical Engineering, and Technology."
                }
            ]
        },
        {
            "name": "Foreign Trade University (FTU)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Research Programs"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Vietnam’s leading business university specializing in International Business, Economics, Finance, Trade, Marketing, and Global Management."
                }
            ]
        },
        {
            "name": "University of Economics Ho Chi Minh City (UEH)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & February"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading economics and business university with strong programs in Finance, Economics, Business Administration, Digital Economy, and Management."
                }
            ]
        },
        {
            "name": "Can Tho University (CTU)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading university in the Mekong Delta region with strengths in Agriculture, Environmental Science, Aquaculture, Biotechnology, Education, and Sustainability."
                }
            ]
        },
        {
            "name": "Hue University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Comprehensive public university with programs in Medicine, Agriculture, Engineering, Education, Economics, and Humanities."
                }
            ]
        },
        {
            "name": "Phenikaa University",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Research Programs"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & February"
                },
                {
                    "label": "Key Strengths",
                    "value": "Emerging private research university focusing on Artificial Intelligence, Engineering, Technology, Health Sciences, and Innovation."
                }
            ]
        },
        {
            "name": "Vietnam Academy of Agriculture (VNUA)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Vietnam’s leading institution for Agriculture, Biotechnology, Food Science, Environmental Studies, Rural Development, and Sustainable Agriculture."
                }
            ]
        },
        {
            "name": "Ho Chi Minh City University of Technology and Education (HCMUTE)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Research Programs"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Strong applied technology university specializing in Engineering Education, Automation, Mechanical Engineering, Electrical Engineering, and Industrial Technology."
                }
            ]
        },
        {
            "name": "Banking University Ho Chi Minh City (BUH)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's & Research Programs"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1–2 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Specialized university focused on Banking, Finance, Economics, Accounting, Business Administration, and Financial Technology."
                }
            ]
        }
    ],
    "europe": [
        {
            "name": "University of Oxford (United Kingdom)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 7.0–7.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1 Year, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October"
                },
                {
                    "label": "Key Strengths",
                    "value": "Europe’s leading university with global excellence in Research, Medicine, Law, Economics, Computer Science, Public Policy, Humanities, and Social Sciences."
                }
            ]
        },
        {
            "name": "ETH Zurich – Swiss Federal Institute of Technology (Switzerland)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1.5–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & February"
                },
                {
                    "label": "Key Strengths",
                    "value": "Europe’s premier science and technology university specializing in Engineering, Computer Science, Artificial Intelligence, Robotics, Data Science, Physics, and Innovation."
                }
            ]
        },
        {
            "name": "Imperial College London (United Kingdom)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5–7.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1 Year, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October"
                },
                {
                    "label": "Key Strengths",
                    "value": "World-leading STEM university with strengths in Engineering, Artificial Intelligence, Medicine, Data Science, Climate Technology, and Innovation."
                }
            ]
        },
        {
            "name": "University of Cambridge (United Kingdom)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 7.0–7.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1 Year, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October"
                },
                {
                    "label": "Key Strengths",
                    "value": "Globally recognized research university with excellence in Engineering, Mathematics, Computer Science, Natural Sciences, Economics, and Medicine."
                }
            ]
        },
        {
            "name": "University College London (UCL) (United Kingdom)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5–7.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3–4 Years, Master's: 1 Year, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September/October"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading multidisciplinary research university known for Computer Science, Engineering, Architecture, Medicine, Education, Psychology, and Social Sciences."
                }
            ]
        },
        {
            "name": "Technical University of Munich (TUM) (Germany)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October & April"
                },
                {
                    "label": "Key Strengths",
                    "value": "Germany’s leading technical university specializing in Engineering, Artificial Intelligence, Computer Science, Robotics, Natural Sciences, Entrepreneurship, and Innovation."
                }
            ]
        },
        {
            "name": "University of Edinburgh (United Kingdom)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5–7.0"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 4 Years, Master's: 1 Year, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Globally recognized university with excellence in Artificial Intelligence, Informatics, Medicine, Engineering, Business, and Research."
                }
            ]
        },
        {
            "name": "EPFL – École Polytechnique Fédérale de Lausanne (Switzerland)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1.5–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Leading European science and engineering institution known for Robotics, Computer Science, AI, Biotechnology, Engineering, and Advanced Research."
                }
            ]
        },
        {
            "name": "LMU Munich (Germany)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "October & April"
                },
                {
                    "label": "Key Strengths",
                    "value": "One of Europe’s leading comprehensive research universities with strengths in Medicine, Natural Sciences, Economics, Law, Humanities, and Social Sciences."
                }
            ]
        },
        {
            "name": "University of Amsterdam (Netherlands)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & February"
                },
                {
                    "label": "Key Strengths",
                    "value": "Research-intensive university known for Artificial Intelligence, Data Science, Economics, Communication, Psychology, and Social Sciences."
                }
            ]
        },
        {
            "name": "Delft University of Technology (Netherlands)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & February"
                },
                {
                    "label": "Key Strengths",
                    "value": "Netherlands’ leading technical university specializing in Engineering, Architecture, Artificial Intelligence, Aerospace, Sustainable Technology, and Innovation."
                }
            ]
        },
        {
            "name": "University of Copenhagen (Denmark)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 2 Years, PhD: 3 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & February"
                },
                {
                    "label": "Key Strengths",
                    "value": "Denmark’s leading research university with strengths in Medicine, Life Sciences, Biotechnology, Environmental Science, Economics, and Research."
                }
            ]
        },
        {
            "name": "KU Leuven (Belgium)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 1–2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Belgium’s leading research university known for Engineering, Science, Business, Medicine, Artificial Intelligence, and Innovation."
                }
            ]
        },
        {
            "name": "Université PSL (France)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 6.0–6.5 (program dependent)"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 2 Years, PhD: 3–5 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September"
                },
                {
                    "label": "Key Strengths",
                    "value": "Elite French research university specializing in Science, Engineering, Mathematics, Economics, Humanities, and Innovation."
                }
            ]
        },
        {
            "name": "University of Bologna (Italy)",
            "highlights": [
                {
                    "label": "Available Programs",
                    "value": "Bachelor's, Master's, Research & Doctorate"
                },
                {
                    "label": "IELTS Requirement",
                    "value": "Usually 5.5–6.5"
                },
                {
                    "label": "Duration",
                    "value": "Bachelor's: 3 Years, Master's: 2 Years, PhD: 3–4 Years"
                },
                {
                    "label": "Intake Timeline",
                    "value": "September & February"
                },
                {
                    "label": "Key Strengths",
                    "value": "One of Europe’s oldest universities with strengths in Law, Economics, Business, Engineering, Medicine, Humanities, and International Programs."
                }
            ]
        }
    ]
};
